import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { StaticPageInterface } from '../../../domain/entites/footer-themes.model';
import { FooterFacade } from '../../../domain/facates/footer-themes.facades';
import { FooterThemesService } from '../../../domain/services/footer-themes.service';
import { BaseComponent, LanguageService } from 'imakeapp-shared';







@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends BaseComponent implements OnInit
{

  current_year : string = new Date().getFullYear().toString();
  site_name: string = '';
  static_pages : StaticPageInterface[] = [];
  payment_types: any[] = [];




  constructor(
    private cookie_s: CookieService,
    private facade: FooterFacade,
    private service: FooterThemesService,
    public override language_s: LanguageService
  ) {
    super(language_s,undefined);
  }

  override ngOnInit(): void
  {
super.ngOnInit()
    // get website attributes
    this.get_web_attributes();


    // set active language
    this.active_language();

    // get static pages
    this.facade.get_static_pages();

    // listen to needed states
    this.listen_to_states();



  }




  get_web_attributes()
  {

    this.facade.get_site_theme();

    this.facade.site_theme_selector$.subscribe(
      (state)=>{
        this.site_name = state['app_name'];
      }
    );


  }


  active_language()
  {



  }


  listen_to_states()
  {

    this.facade.static_pages_selector$.subscribe(
      (state)=>{
        this.static_pages = state;
      },
      (err)=>{
        console.error(err);
      }
    );


    // TODO: change this later put it in facades
    this.service.get_payment_types().subscribe(
      (data: any)=>{
        this.payment_types = data?.data?.paymenttypes;
      },
      (err)=>{
        console.log(err);
      }
    );

  }


  scroll_to_top()
  {

    // other browsers
    window.scrollTo(0,0);

    // chrome
    window.document.body.scrollTop = 0;

  }





}
